/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { GetProductsAsGroupName200ResponseDataInner } from './GetProductsAsGroupName200ResponseDataInner'
import {
  GetProductsAsGroupName200ResponseDataInnerFromJSON,
  GetProductsAsGroupName200ResponseDataInnerFromJSONTyped,
  GetProductsAsGroupName200ResponseDataInnerToJSON,
} from './GetProductsAsGroupName200ResponseDataInner'

/**
 *
 * @export
 * @interface GetProductsAsGroupName200Response
 */
export interface GetProductsAsGroupName200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetProductsAsGroupName200Response
   */
  status: boolean
  /**
   *
   * @type {Array<GetProductsAsGroupName200ResponseDataInner>}
   * @memberof GetProductsAsGroupName200Response
   */
  data: Array<GetProductsAsGroupName200ResponseDataInner>
}

/**
 * Check if a given object implements the GetProductsAsGroupName200Response interface.
 */
export function instanceOfGetProductsAsGroupName200Response(
  value: object
): value is GetProductsAsGroupName200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetProductsAsGroupName200ResponseFromJSON(
  json: any
): GetProductsAsGroupName200Response {
  return GetProductsAsGroupName200ResponseFromJSONTyped(json, false)
}

export function GetProductsAsGroupName200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetProductsAsGroupName200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: (json['data'] as Array<any>).map(
      GetProductsAsGroupName200ResponseDataInnerFromJSON
    ),
  }
}

export function GetProductsAsGroupName200ResponseToJSON(
  value?: GetProductsAsGroupName200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: (value['data'] as Array<any>).map(
      GetProductsAsGroupName200ResponseDataInnerToJSON
    ),
  }
}
